/* eslint-disable max-len */
import React from "react";

import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const AudioWaveIcon: FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path d="M3 17C3 17.5523 3.44772 18 4 18C4.55228 18 5 17.5523 5 17V14C5 13.4477 4.55228 13 4 13C3.44772 13 3 13.4477 3 14V17Z" />
      <path d="M7 21V10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10V21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21Z" />
      <path d="M23 21V10C23 9.44772 23.4477 9 24 9C24.5523 9 25 9.44772 25 10V21C25 21.5523 24.5523 22 24 22C23.4477 22 23 21.5523 23 21Z" />
      <path d="M11 27C11 27.5523 11.4477 28 12 28C12.5523 28 13 27.5523 13 27L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L11 27Z" />
      <path d="M15 19V12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19Z" />
      <path d="M19 25V7C19 6.44772 19.4477 6 20 6C20.5523 6 21 6.44772 21 7V25C21 25.5523 20.5523 26 20 26C19.4477 26 19 25.5523 19 25Z" />
      <path d="M27 17C27 17.5523 27.4477 18 28 18C28.5523 18 29 17.5523 29 17V14C29 13.4477 28.5523 13 28 13C27.4477 13 27 13.4477 27 14V17Z" />
    </BaseIcon>
  );
};
